import _ from 'lodash';

export const getSelectedCoELabel = (certificates, selectedCoE) => {
    const selectedSeason = certificates.find(c => c.id === selectedCoE);

    return _.get(selectedSeason, 'display_date', null);
};
